const LOG_IN = 'LOG_IN'

const state = {
    isLoggedIn: false,
}

const actions = {
    logIn({ commit }) {
        commit(LOG_IN)
    },
}

const mutations = {
    [LOG_IN](state) {
        state.isLoggedIn = true
    },
}

export default {
    state,
    actions,
    mutations
}